import { Route } from "react-router-dom";
import { pages } from "../../../utils/common";
import AuditTrailView from "./auditTrail.view";

const useAuditTrailRoutes = () => (
  <Route path={pages.auditTrail.path} element={<AuditTrailView />}>
    <Route index element={<AuditTrailView />} />
  </Route>
);

export default useAuditTrailRoutes;
